<template>
  <div>
     <div class="flex items-start">
      {{ $t('您的购物车共有{num}件商品').replace('{num}', cart_infoLength) }}
    </div>
    <div class="my-8" v-if="cart_infoLength">
      <CartBody></CartBody>
    </div>
    <div v-if="cart_infoLength">
      <CartFoot></CartFoot>
    </div>
    <div v-else class="flex-center w-full mt-10rem">
      <img :src="require(`@/assets/image/暂无数据.png`)" />
    </div> 
  </div>
</template>
<script>
import CartBody from "/src/components/mine/cart/cartBody.vue";
import CartFoot from "/src/components/mine/cart/cartFoot.vue";
import { computed, ref } from "@vue/composition-api";

export default {
  components: {  CartBody, CartFoot },
  setup(props, ctx) {
    const cartLists = ref()
    const getCartLists = async () => {
      ctx.root.$doing()
      let res = await ctx.root.$callapi('trade/getMyCartList')
      ctx.root.$done()
      if (res.code == 0 && res.data) {
        cartLists.value = res.data
        ctx.root.$store.commit("SAVE_CART", res.data);

      }
    }
    getCartLists()
    const cart_info = computed(() => {
      return ctx.root.$store.state.cart.cart;
    });
    const cart_infoLength = computed(() =>
      cart_info?.value?.length ? cart_info.value.length : 0
    );

    return { cart_infoLength, cartLists };
  },
};
</script>
<style scoped lang="scss">

</style>
